import { useState, useEffect } from 'react';
import { useApi } from 'utils';

interface AccountData {
    linked_account_id: number;
    linked_account_code: string;
    linked_account_name: string;
    description: string;
    coa_id: number;
    coa_code: string;
    coa_name: string;
    group_coa_code: string;
    group_coa_name: string;
}

export function useAccountCode(link_account: string) {
    const [accountData, setAccountData] = useState<AccountData | null>(null);
    const api = useApi();

    useEffect(() => {
        const fetchData = async () => {
        try {
            const response = await api.get('linkedaccount/bycode', {
            params: {
                linked_account_code: link_account
            }
            });
            
            const data = response.data.payload?.[0];
            
            if (data) {
            setAccountData({
                linked_account_id: data.linked_account_id,
                linked_account_code: data.linked_account_code,
                linked_account_name: data.linked_account_name,
                description: data.description,
                coa_id: data.coa_id,
                coa_code: data.coa_code,
                coa_name: data.coa_name,
                group_coa_code: data.group_coa_code,
                group_coa_name: data.group_coa_name
            });
            } else {
            setAccountData(null);
            }
        } catch (err) {
            console.log(err instanceof Error ? err.message : 'An error occurred');
            setAccountData(null);
        } finally {
            //
        }
        };

        if (link_account) {
            fetchData();
        } else {
            setAccountData(null);
        }
         // eslint-disable-next-line
    }, []);

    return { accountData };
}